<template>
  <div v-if="isString(backgroundText)" class="ai-response-loader">
    <pre v-highlightjs="backgroundText" :key="backgroundText" class="h-100 d-flex flex-column">
      <code class="javascript">
      </code>
    </pre>
    <span :class="classes">
      <span class="material-icons">auto_awesome</span>
    </span>
  </div>
  <span :class="classes" v-else>
    <span class="material-icons">auto_awesome</span>
  </span>
</template>

<script>
import { isString } from 'lodash'

export default {
  name: 'AIResponseLoader',
  methods: { isString },
  props: ['noBackground', 'backgroundText'],
  computed: {
    classes() {
      const classes = []
      if (this.noBackground) classes.push('noBackground')
      classes.push('ai-loader')
      return classes.join(' ')
    },
  },
}
</script>

<style scoped lang="scss">
.noBackground.ai-loader {
  background: transparent;
}

.ai-loader {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #282c34;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.ai-loader span {
  font-size: 2.5em;
  z-index: 100;
  color: $background-color-ai-dark;
}

.ai-loader:before,
.ai-loader:after {
  content: '';
  border-radius: 50%;
  position: absolute;
  inset: 0;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.3) inset;
}

.ai-loader:after {
  box-shadow: 0 2px 0 $background-color-ai inset;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ai-response-loader {
  position: relative;
  height: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.ai-response-loader::-webkit-scrollbar {
  display: none;
}

code {
  height: $code-editor-height;
  overflow: auto;
  word-wrap: break-word;
  white-space: break-spaces;
  line-height: 1.5em;
  padding: 2em;
}
</style>
